<template>
  <div
    class="lg:px-20 md:px-12 px-4 lg:py-20 md:py-12 lg:mb-0 md:mb-0 mb-12 md:mt-0 lg:mt-0 mt-20"
  >
    <div>
      <p class="fsize24-14 lh32px text-center font-semibold">HELIX ARTS</p>
    </div>
    <div class="bg-color mt-2 m-auto rounded-md heightWidth"></div>
    <div class="mt-4 lg:w-7/12 md:w-7/12 w-4/5 m-auto">
      <p
        class="lg:mt-2 md:mt-2 mt-2 sm-fsize14 lg:text-center md:text-center textleft"
      >
        This film is made by Helix Arts. It will introduce you to the concept of
        creative journaling, it prompts you to create a care Cairn. This might
        be as guided in the film or your own take on it.
      </p>
      <p
        class="lg:mt-2 md:mt-2 mt-2 sm-fsize14 lg:text-center md:text-center textleft"
      >
        You may dip in and out of each page or journal experience as suits you.
      </p>
      <p
        class="lg:mt-2 md:mt-2 mt-2 sm-fsize14 lg:text-center md:text-center textleft"
      >
        We invite you to make something to represent you, how you care and how
        people perceive care and the role of carers across society.
      </p>
      <p
        class="lg:mt-2 md:mt-2 mt-2 sm-fsize14 lg:text-center md:text-center textleft"
      >
        This can be literal, abstract, traditional or alternative. Over to you
        ....
      </p>
      <p
        class="lg:mt-2 md:mt-2 mt-2 sm-fsize14 lg:text-center md:text-center textleft"
      >
        Share your artwork with us here so it can become part of the digital
        gallery or email us at
        <a href="mailto:info@helixarts.com" class="textcolor underline"
          >info@helixarts.com</a
        >
        and we will guide you further.
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.textcolor {
  color: #4a0a4b;
}
.bg-color {
  background-color: #94abca;
}
.heightWidth {
  height: 25rem;
  width: 80%;
}
@media (max-width: 640px) {
  .heightWidth {
    height: 10rem;
    width: 80%;
  }
  .textleft {
    text-align: left !important;
  }
}
</style>
